import React, { useState } from 'react';
import { ProtectedRoute } from '../../../components/ProtectedRoute';
import {
  StockTabs,
  DashboardTab,
  TransfersTab,
  BatchExpiryTab,
  HoldReserveTab,
  AdjustmentsTab,
} from './components';
import type { StockTab } from './stockManagementTypes';
import styles from './AdminStockManagement.module.css';

const AdminStockManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<StockTab>('dashboard');

  return (
    <div className={styles.container}>
      {/* Tab Bar */}
      <StockTabs activeTab={activeTab} onTabChange={setActiveTab} />

      {/* Tab Content */}
      {activeTab === 'dashboard' && <DashboardTab />}
      {activeTab === 'transfers' && <TransfersTab />}
      {activeTab === 'adjustments' && <AdjustmentsTab />}
      {activeTab === 'batchExpiry' && <BatchExpiryTab />}
      {activeTab === 'holdReserve' && <HoldReserveTab />}
    </div>
  );
};

export const AdminStockManagementPage: React.FC = () => (
  <ProtectedRoute requiredRoles={['admin']}>
    <AdminStockManagement />
  </ProtectedRoute>
);

export { AdminStockManagement };
export default AdminStockManagement;
